import {Route, Routes} from "react-router-dom";
import React from "react";
import Lander from "./components/Lander";
import AgendaView from "./components/AgendaView";
import {Box} from "@mui/material";

const routes = (
    <Routes>
        <Route path="/" element={<Lander />}/>
        <Route path="/:organizationName/:agendaId" element={<AgendaView/>}/>
    </Routes>
)

const App = () => {

    return (
        <Box className="App">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    p: 2
                }}
            >
                <Box
                    sx={{
                        flex: 1
                    }}
                >
                    {routes}
                </Box>
            </Box>


        </Box>
    );
}

export default App;
